var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"message-div"},[_vm._v("\n  "+_vm._s(_vm.$t('contact_or_meet_us'))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }